/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Typst_Locked_HintInputs */

const cs_builder_typst_locked_hint = /** @type {(inputs: Builder_Typst_Locked_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzamčeno na vizuální layout — úpravy zůstávají 1:1. Odemkněte pro ruční Typst.`)
};

const en_builder_typst_locked_hint = /** @type {(inputs: Builder_Typst_Locked_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locked to the visual layout — edits stay 1:1. Unlock to hand-tune Typst.`)
};

/**
* | output |
* | --- |
* | "Locked to the visual layout — edits stay 1:1. Unlock to hand-tune Typst." |
*
* @param {Builder_Typst_Locked_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_typst_locked_hint = /** @type {((inputs?: Builder_Typst_Locked_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Typst_Locked_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_typst_locked_hint(inputs)
	return cs_builder_typst_locked_hint(inputs)
});